import axios from 'axios';

const getRespostas = (idCotacao, params) => axios.get(`/cotacoes-fretes/${idCotacao}/respostas`, {
  params,
});

const getRecusadas = (idCotacao, params) => axios.get(`/cotacoes-fretes/${idCotacao}/respostas/nao-transporta`, {
  params,
});

const getResposta = (idCotacao, idResposta) => axios.get(`/cotacoes-fretes/${idCotacao}/respostas/${idResposta}`);

const getHistorico = (idCotacao, idResposta) => axios.get(`/cotacoes-fretes/${idCotacao}/respostas/${idResposta}/historico`);
const notificarNegociacao = idResposta => axios.post(`/notificacoes/negociacao_cotacao_frete/${idResposta}`, {});

export default {
  getRespostas,
  getRecusadas,
  getResposta,
  getHistorico,
  notificarNegociacao,
};
